export default class ClienteEmail {
  constructor(
    id_cliente = null,
    id_item = null,
    tipo_email = 'GERAL',
    email = '',
    versao_imp = 0
  ) {
    this.id_cliente = id_cliente;
    this.id_item = id_item;
    this.tipo_email = tipo_email;
    this.email = email;
    this.versao_imp = versao_imp;
  }
}